import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-vox',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>VOX icon</title><path d="M0 8.198l4.182 7.604h2.442L8.15 13.07a4.276 4.276 0 0 1 2.054-4.872H7.112l-1.677 3.216-1.706-3.216zm14.342 0a4.24 4.24 0 0 1 1.923 2.206c.784 2.081-.098 4.415-2.145 5.398h2.767l1.564-1.754 1.42 1.754H24l-3.505-4.032 3.088-3.572H19.41l-.952 1.249-.931-1.249zm-2.09 1.596c-.949 0-1.913.69-2.074 1.775a2.132 2.132 0 0 0 2.064 2.483c1.268.01 2.192-1.126 2.156-2.18-.013-1.015-.877-2.08-2.146-2.078z"/></svg>`,
    styles: []
})
export class SimpleIconsVoxComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#DA074A';
    @Input() className: string = 'simple-icons-vox'
    constructor() {}
    ngOnInit(): void {}
}
